// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 12 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12">
            <path
                fill="currentColor"
                d="M1.5,1.5 C1.5,0.6796875 2.1796875,0 3,0 L8.015625,0 C8.4140625,0 8.7890625,0.1640625 9.0703125,0.4453125 L10.0546875,1.4296875 C10.3359375,1.7109375 10.5,2.109375 10.5,2.5078125 L10.5,3.375 L1.5,3.375 L1.5,1.5 Z M0,6 C0,5.1796875 0.6796875,4.5 1.5,4.5 L10.5,4.5 C11.3203125,4.5 12,5.1796875 12,6 L12,8.25 C12,8.671875 11.671875,9 11.25,9 L10.5,9 L10.5,10.5 C10.5,11.3203125 9.8203125,12 9,12 L3,12 C2.1796875,12 1.5,11.3203125 1.5,10.5 L1.5,9 L0.75,9 C0.328125,9 0,8.671875 0,8.25 L0,6 Z M3,9.75 L3,10.5 L9,10.5 L9,8.25 L3,8.25 L3,9.75 Z M10.6875,6.375 C10.6875,6.0703125 10.4296875,5.8125 10.125,5.8125 C9.8203125,5.8125 9.5625,6.0703125 9.5625,6.375 C9.5625,6.6796875 9.8203125,6.9375 10.125,6.9375 C10.4296875,6.9375 10.6875,6.6796875 10.6875,6.375 Z"
            />
        </svg>
    );
};

export default React.memo(Print);
